export default Object.freeze({
  DOCUMENTS_LOAD: Symbol('DOCUMENTS_LOAD'),
});
